import { useEffect, useRef, useState } from "react";

// Tracks whether tooltips should open instantly (within 400ms of last tooltip close) or with a delay.
class TooltipManager {
  private static cooldown: NodeJS.Timeout | null = null;
  static immediate = false;

  static onOpen = () => {
    if (this.cooldown) clearTimeout(this.cooldown);
    this.cooldown = null;
    this.immediate = true;
  };

  static onClose = () => {
    if (this.cooldown) clearTimeout(this.cooldown);
    this.cooldown = setTimeout(() => {
      this.immediate = false;
      this.cooldown = null;
    }, 400);
  };
}

export const useTooltips = () => {
  const [isOpen, setIsOpen] = useState(false);
  const delayTimer = useRef<NodeJS.Timeout | null>(null);
  const isOpenRef = useRef(false);
  isOpenRef.current = isOpen;

  const clearDelay = () => {
    if (delayTimer.current) {
      clearTimeout(delayTimer.current);
      delayTimer.current = null;
    }
  };

  useEffect(() => {
    return () => {
      clearDelay();
      if (isOpenRef.current) TooltipManager.onClose();
    };
  }, []);

  const open = () => {
    clearDelay();

    if (TooltipManager.immediate) {
      TooltipManager.onOpen();
      setIsOpen(true);
    } else {
      delayTimer.current = setTimeout(() => {
        delayTimer.current = null;
        TooltipManager.onOpen();
        setIsOpen(true);
      }, 700);
    }
  };

  const close = () => {
    clearDelay();
    setIsOpen(false);
    TooltipManager.onClose();
  };

  return { isOpen, open, close };
};
